
const initialState = () => ({
    isEdit: false,
    zone_form: {
        FRI: "0",
        MON: "0",
        SAT: "0",
        SUN: "0",
        THU: "0",
        TUE: "0",
        WED: "0",
        ZONE_NAME: "",
        ZONE_TYPE: "",
        ZONE_AREA:[{
            ZONE_ID: "", 
            PROVINCE: "", 
            AREA: []
        }],
        NEW_AREA:[]
    },
});

const state = initialState()


const getters = {
    GET_ELEMENT: state => state.zone_form,
    IS_EDIT: state => state.isEdit,

}

const mutations = {
    SET_ALL_ELEMENT(state, data) {
        state.zone_form = Object.assign({}, data);
    },
    SET_ELEMENT(state, data) {
        state.zone_form[data.key] = data.value;
    },
    SET_ZONE_AREA(state, data){
        state.zone_form.ZONE_AREA = data
    },
    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },

}

const actions = {
    remove_zone_list(context, items) {
        let data = context.state.zone_form.ZONE_AREA
        const index = data.indexOf(items)
        data.splice(index, 1);
        context.commit('SET_ZONE_AREA', data)
    },
    add_zone_list(context, items) {
        let data = context.state.zone_form.ZONE_AREA
        data.push(items)
        data[data.length - 1].INDEX = parseInt(data.length) - 1
        context.commit('SET_ZONE_AREA', data)
    },
    reset({ commit }) {
        commit('RESET');
    }
}
// Mutations

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}